/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Billing_Last_Bill_PendingInputs */

const es_admin_billing_last_bill_pending = /** @type {(inputs: Admin_Billing_Last_Bill_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente`)
};

const en_admin_billing_last_bill_pending = /** @type {(inputs: Admin_Billing_Last_Bill_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Admin_Billing_Last_Bill_PendingInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_last_bill_pending = /** @type {((inputs?: Admin_Billing_Last_Bill_PendingInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Last_Bill_PendingInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_last_bill_pending(inputs)
	return en_admin_billing_last_bill_pending(inputs)
});
export { admin_billing_last_bill_pending as "admin.billing.last_bill.pending" }